import { Paper, Grid } from '@mui/material';
import { deviceSizes } from '@app/config/devices';
import Accordion from '@mui/material/Accordion';
import styled from 'styled-components';

export const DashboardContainer = styled(Paper)`
  padding: 1rem;
  width: 100%;
  max-width: 69rem;
  min-height: 500px;
  && {
    border-radius: 16px;
  }
`;

export const TemplateContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
    align-items: center;
`;

export const FooterContainer = styled.div`
  flex-direction: row;
  align-items: center;
  justify-content: center;
  display: flex;
  h6 {
    align-items: center;
    display: flex;
    justify-content: center;
  }
`;

export const NavTabsContainer = styled(Grid)`
  @media (max-width:${deviceSizes.mobileL}) {
    .fMyAGq {
      flex-direction: column;
    }
  }
`

export const StyledAccordion = styled(Accordion)`
  && {

    .MuiAccordionSummary-root.Mui-expanded{
      min-height: 0px;
      height: 40px;
      margin-top:30px;
      
    }
  }

  @media (max-width:${deviceSizes.mobileL}) {
    max-height: 300px;
    overflow-y: auto;
  }
`;

export const StyledSummaryBoxes = styled.div`
  display: flex;
  align-items: center;
  p{
    text-transform: uppercase;
    font-weight:600;
  }
  svg {
    margin-right: 10px;
    color: ${({ theme }) => theme.secondaryColor[700]};
    font-size: 20px;
  }
  .electric-guitar {
    margin-right: 10px;
    color: ${({ theme }) => theme.secondaryColor[700]};
  }
`;

export const BodyContainer = styled.div`
  padding-left: 4.875rem;
  padding-right: 4.875rem;
  
  @media (max-width: 600px) {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  // @media ${deviceSizes.mobileL} {
  //   padding-left: 1.875rem;
  //   padding-right: 1.875rem;
  // } 
`;